document.querySelectorAll('.faq__category-questionCat').forEach(function(cat) {
	cat.addEventListener('click', function() {
		cat.closest('.faq__category-questionBlock').classList.toggle('is-open');
	});
});
